// Components
import StickyBrandingHeader from './StickyBrandingHeader'
import StickyBrandingContactInfo from './StickyBrandingContactInfo'

// Styles
import styles from './StickyBranding.module.scss'

const StickyBranding = () => (
  <div className={styles.sticky}>
    <StickyBrandingHeader />
    <StickyBrandingContactInfo />
  </div>
)

export default StickyBranding
